import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/svgFont/style.css'
import './less/custom.less'
import './less/common.less';

import 'ant-design-vue/dist/antd.css';
//注入全局属性$message
import {
  message,
  notification,
  Modal
} from 'ant-design-vue'
Vue.prototype.$message = message
Vue.prototype.$notification = notification
message.config({
  top: `80px`,
  duration: 2,
  maxCount: 3,
})
Vue.use(Modal)

import 'normalize.css/normalize.css'
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
